<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="changeTab(0)">
          未读消息({{ messageListA.length }})
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="changeTab(1)">
          已读消息({{ messageListB.length }})
        </li>
        <li :class="{ active: tabIndex === 2 }" @click="changeTab(2)">
          课程更新({{ messageWithCourseListA.length }})
        </li>
        <!-- <li :class="{ active: tabIndex === 3 }" @click="changeTab(3)">
          串讲上线({{ messageWithCourseListB.length }})
        </li> -->
      </ul>
    </div>
    <div class="member-main-body">
      <div class="no-data" v-show="messageList.length == 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p>暂无消息</p>
      </div>
      <div class="message-list" v-show="messageType == 1">
        <div
          class="message-item"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="item-icon">
            <Icon custom="ich-icon ich-icon-u-message" size="22"></Icon>
          </div>
          <div class="item-content">
            <p @click="showDetail(item)">
              {{ item.title }}<span>{{ item.pubtime }}</span>
            </p>
            <p>{{ item.content }}</p>
          </div>
          <div class="item-action">
            <Poptip
              confirm
              title="您确定要删除当前信息么?"
              @on-ok="deleteMessage(item.unid)"
              popper-class="tip-width"
              placement="top-end"
            >
              <div class="delete-icon">
                <Icon custom="ich-icon ich-icon-delete" size="22"></Icon>
              </div>
            </Poptip>
          </div>
          <Drawer
            :title="item.title"
            width="640"
            :closable="false"
            v-model="item.detailVisible"
          >
            <div v-html="item.content"></div>
            <div v-if="item.fileList && item.fileList.length">
              <div class="files-title">附件下载</div>
              <div class="files-data">
                <div class="table-tr">
                  <div class="table-th">文件名</div>
                  <div class="table-th">操作</div>
                </div>
                <div
                  class="table-tr"
                  v-for="(file, index) in item.fileList"
                  :key="index"
                >
                  <div class="table-td" :title="file.name">
                    {{ file.name }}
                  </div>
                  <div class="table-td">
                    <a
                      v-if="
                        file.url.indexOf('jpg') >= 0 ||
                          file.url.indexOf('jpeg') >= 0 ||
                          file.url.indexOf('png') >= 0 ||
                          file.url.indexOf('gif') >= 0
                      "
                      :href="
                        file.url +
                          '?response-content-type=application/octet-stream'
                      "
                      >下载</a
                    >
                    <a v-else :href="file.url">下载</a>
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      </div>
      <div class="message-list" v-show="messageType == 2">
        <div
          class="message-item"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="item-icon">
            <Icon custom="ich-icon ich-icon-u-message" size="22"></Icon>
          </div>
          <div class="item-content">
            <p>
              {{ item.content }}<span>{{ item.createTime }}</span>
            </p>
            <p>{{ item.content }}</p>
          </div>
          <div class="item-action">
            <Poptip
              confirm
              title="您确定要删除当前信息么?"
              @on-ok="deleteMessage(item.uCID)"
              popper-class="tip-width"
              placement="top-end"
            >
              <div class="delete-icon">
                <Icon custom="ich-icon ich-icon-delete" size="22"></Icon>
              </div>
            </Poptip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { user, study } from '../../request';
export default {
  mixins: [siteMixin],
  data() {
    return {
      tabIndex: 0,
      isRead: 0,
      messageType: 1,
      messageListA: [],
      messageListB: [],
      courseType: -1,
      messageWithCourseListA: [],
      messageWithCourseListB: [],
    };
  },
  computed: {
    messageList() {
      switch (this.tabIndex) {
        case 0:
          return this.messageListA;
        case 1:
          return this.messageListB;
        case 2:
          return this.messageWithCourseListA;
        case 3:
          return this.messageWithCourseListB;
        default:
          return [];
      }
    },
  },
  mounted() {
    this.setMetaData('我的消息');
    this.getMessage();
    this.getMessageWithCourse();
  },
  methods: {
    getMessage() {
      user.getMessage(0, this.loginUser.userId).then((res) => {
        //console.log("messageA", res);
        if (res.status === 1) {
          this.messageListA = res.data;
          this.messageListA.forEach((item) => {
            this.$set(item, 'detailVisible', false);
            this.$set(
              item,
              'fileList',
              item.files ? JSON.parse(item.files) : []
            );
          });
        }
      });
      user.getMessage(1, this.loginUser.userId).then((res) => {
        //console.log("messageA", res);
        if (res.status === 1) {
          this.messageListB = res.data;
          this.messageListB.forEach((item) => {
            this.$set(item, 'detailVisible', false);
            this.$set(
              item,
              'fileList',
              item.files ? JSON.parse(item.files) : []
            );
          });
        }
      });
    },
    getMessageWithCourse() {
      user.getMessageWithCourse(-1, this.loginUser.userId, 1).then((res) => {
        console.log('messageB', res);
        if (res.status === 1) {
          this.messageWithCourseListA = res.data;
          this.messageWithCourseListA.forEach((item) => {
            this.$set(item, 'detailVisible', false);
            this.$set(
              item,
              'fileList',
              item.files ? JSON.parse(item.files) : []
            );
          });
        }
      });
      // user.getMessageWithCourse(-1, this.loginUser.userId, 2).then((res) => {
      //   //console.log("messageB", res);
      //   if (res.status === 1) {
      //     this.messageWithCourseListB = res.data;
      //   }
      // });
    },
    changeTab(index) {
      if (this.tabIndex == index) return;
      this.tabIndex = index;
      if (this.tabIndex < 2) {
        this.messageType = 1;
      } else {
        this.messageType = 2;
      }
    },
    showDetail(item) {
      item.detailVisible = true;
      user.setMessageReaded(item.unid, this.messageType).then((res) => {
        //console.log(res);
      });
    },
    deleteMessage(id) {
      user.deleteMessage(id, this.messageType).then((res) => {
        if (res.status === 1) {
          this.$Message.success('删除成功');
          if (this.messageType === 1) {
            this.getMessage();
          } else {
            this.getMessageWithCourse();
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/css/var';
@import '../../assets/css/member-main.less';
.message-list {
  padding: 0 30px 30px 30px;
  .message-item {
    display: flex;
    padding: 30px 0;
    border-bottom: 1px dashed #ececec;
    .item-icon {
      width: 52px;
      height: 52px;
      background: #f8f8f8;
      border-radius: 50px;
      color: #41a5fd;
      text-align: center;
      line-height: 52px;
    }
    .item-content {
      flex: 1;
      margin-left: 10px;
      p {
        &:first-child {
          font-weight: bold;
          cursor: pointer;
          span {
            font-size: 12px;
            color: #666;
            margin-left: 10px;
            font-weight: normal;
          }
        }
        &:last-child {
          margin-top: 15px;
          color: #666;
          width: 700px;
          .ellipsis();
        }
      }
    }
    .item-action {
      color: #666;
      width: 40px;
      height: 30px;
      line-height: 30px;
      text-align: left;
      margin-top: 15px;
      .delete-icon {
        width: 32px;
        cursor: pointer;
        &:hover {
          color: #41a5fd;
        }
      }
      /deep/.tip-width {
        width: 230px;
      }
    }
  }
}
.files-title {
  margin-top: 24px;
  font-size: 16px;
  font-weight: bold;
}
.files-data {
  margin-top: 12px;
  border: 1px solid #ccc;
  // border-radius: 6px;
  overflow: hidden;
  .table-tr {
    display: flex;
    &:nth-child(2n) {
      background: #f3fbff;
    }
    .table-th {
      font-weight: bold;
    }
    .table-th,
    .table-td {
      padding: 5px 5px;
      text-align: center;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      margin-top: -1px;
      margin-left: -1px;
      .ellipsis();
      &:first-child {
        width: 700px;
      }
      &:last-child {
        width: 120px;
        a {
          margin: 0 8px;
          &:first-child {
            color: #0092e6;
          }
          &:last-child {
            color: #ff4f4f;
          }
        }
      }
    }
  }
}
</style>
